export enum LayerFieldsCommon {
    objectid = "objectid",
    globalid = "globalid",
    sjomerke_nr = "sjomerke_nr",
    bygg_tilstand = "bygg_tilstand",
    nautisk_tilstand = "nautisk_tilstand",
    nautisk_funksjon = "nautisk_funksjon",
    kystverk_rode = "kystverk_rode",
    navn = "navn",
    sted = "sted",
    beliggenhet = "beliggenhet",
    beskrivelse = "beskrivelse",
    byggehoyde = "byggehoyde",
    nfs_status = "nfs_status",
    oppdatert_av = "oppdatert_av",
    oppdatert_dato = "oppdatert_dato",
}

export enum LayerFieldsLys {
    objectid = "objectid",
    globalid = "globalid",
    sjomerke_nr = "sjomerke_nr",
    lys_type = "lys_type",
    lys_farge = "lys_farge",
    klasse = "klasse",
    nfs_status = "nfs_status",
    gis_obj_id = "gis_obj_id",
    navigasjonsinstallasjon_eier = "navigasjonsinstallasjon_eier",
    kystverk_region = "kystverk_region",
    lys_karakter = "lys_karakter",
    retningslys_retning = "retningslys_retning",
    lys_hoyde = "lys_hoyde",
    rekkevidde_hvit = "rekkevidde_hvit",
    rekkevidde_rod = "rekkevidde_rod",
    rekkevidde_gronn = "rekkevidde_gronn",
    rekkevidde_gul = "rekkevidde_gul",
    lysstyrke_hvit = "lysstyrke_hvit",
    lysstyrke_rod = "lysstyrke_rod",
    lysstyrke_gronn = "lysstyrke_gronn",
    lysstyrke_gul = "lysstyrke_gul",
    bakgrunnsbelysning = "bakgrunnsbelysning",
    opprettet_dato = "opprettet_dato",
    oppdatert_dato = "oppdatert_dato",
    oppdatert_av = "oppdatert_av",
    malt_dato = "malt_dato",
    malt_av = "malt_av",
    linse_orden = "linse_orden",
    linse_type = "linse_type",
    antall_identiske_lys = "antall_identiske_lys",
    type_id = "type_id",
    gyldig_fra = "gyldig_fra",
    gyldig_til = "gyldig_til",
    nav_id = "nav_id",
    s57_status = "s57_status",
    sksd_status = "sksd_status",
    bygg_tilstand = "bygg_tilstand",
    nautisk_tilstand = "nautisk_tilstand",
    nautisk_funksjon = "nautisk_funksjon",
    kystverk_rode = "kystverk_rode",
    navn = "navn",
    sted = "sted",
    beliggenhet = "beliggenhet",
    beskrivelse = "beskrivelse",
    byggehoyde = "byggehoyde",
    pacc = "pacc",
    lys = "lys",
    kategori = "kategori",
    lampe = "lampe",
    lys_gjennomgang = "lys_gjennomgang",
    opprettet_av = "opprettet_av",
    navigasjonsinstallasjon_eier_h = "navigasjonsinstallasjon_eier_h",
    type_id_h = "type_id_h",
    beskrivelse_h = "beskrivelse_h",
    karakter = "karakter",
    periode = "periode",
    karakter_h = "karakter_h",
    periode_h = "periode_h",
    nedlagt_av = "nedlagt_av",
    nedlagt_dato = "nedlagt_dato",
    fjernet_av = "fjernet_av",
    fjernet_dato = "fjernet_dato",
    efs_melding = "efs_melding",
    efs_sendt_av = "efs_sendt_av",
}

export enum LayerFieldsIB {
    objectid = "objectid",
    globalid = "globalid",
    sjomerke_nr = "sjomerke_nr",
    gis_obj_id = "gis_obj_id",
    lys_type = "lys_type",
    navigasjonsinstallasjon_eier = "navigasjonsinstallasjon_eier",
    nfs_status = "nfs_status",
    kystverk_region = "kystverk_region",
    lys_karakter = "lys_karakter",
    lys_farge = "lys_farge",
    retningslys_retning = "retningslys_retning",
    lys_hoyde = "lys_hoyde",
    rekkevidde_hvit = "rekkevidde_hvit",
    rekkevidde_rod = "rekkevidde_rod",
    rekkevidde_gronn = "rekkevidde_gronn",
    rekkevidde_gul = "rekkevidde_gul",
    lysstyrke_hvit = "lysstyrke_hvit",
    lysstyrke_rod = "lysstyrke_rod",
    lysstyrke_gronn = "lysstyrke_gronn",
    lysstyrke_gul = "lysstyrke_gul",
    bakgrunnsbelysning = "bakgrunnsbelysning",
    opprettet_dato = "opprettet_dato",
    oppdatert_dato = "oppdatert_dato",
    oppdatert_av = "oppdatert_av",
    malt_dato = "malt_dato",
    malt_av = "malt_av",
    linse_orden = "linse_orden",
    linse_type = "linse_type",
    antall_identiske_lys = "antall_identiske_lys",
    type_id = "type_id",
    gyldig_fra = "gyldig_fra",
    gyldig_til = "gyldig_til",
    nav_id = "nav_id",
    s57_status = "s57_status",
    sksd_status = "sksd_status",
    bygg_tilstand = "bygg_tilstand",
    nautisk_tilstand = "nautisk_tilstand",
    nautisk_funksjon = "nautisk_funksjon",
    kystverk_rode = "kystverk_rode",
    navn = "navn",
    sted = "sted",
    beliggenhet = "beliggenhet",
    klasse = "klasse",
    beskrivelse = "beskrivelse",
    byggehoyde = "byggehoyde",
    pacc = "pacc",
    lys = "lys",
    kategori = "kategori",
    opprettet_av = "opprettet_av",
    navigasjonsinstallasjon_eier_h = "navigasjonsinstallasjon_eier_h",
    type_id_h = "type_id_h",
    beskrivelse_h = "beskrivelse_h",
    karakter = "karakter",
    periode = "periode",
    karakter_h = "karakter_h",
    periode_h = "periode_h",
    nedlagt_av = "nedlagt_av",
    nedlagt_dato = "nedlagt_dato",
    fjernet_av = "fjernet_av",
    fjernet_dato = "fjernet_dato",
    efs_melding = "efs_melding",
    tilknyttet_hib = "tilknyttet_hib",
    tilknyttet_fl_la = "tilknyttet_fl_la",
    efs_sendt_av = "efs_sendt_av",
}

export enum LayerFieldsSektorLinje {
    objectid = "objectid",
    globalid = "globalid",
    fksektorid = "fksektorid",
    nfs_status = "nfs_status",
    opprettet_av = "opprettet_av",
    opprettet_dato = "opprettet_dato",
    oppdatert_av = "oppdatert_av",
    oppdatert_dato = "oppdatert_dato",
    Shape__Length = "Shape__Length",
    malt_av = "malt_av",
    malt_dato = "malt_dato",
    nedlagt_av = "nedlagt_av",
    nedlagt_dato = "nedlagt_dato",
    fjernet_av = "fjernet_av",
    fjernet_dato = "fjernet_dato",
}

export enum LayerFieldsFastSjomerke {
    objectid = "objectid",
    globalid = "globalid",
    gis_obj_id = "gis_obj_id",
    oppdatert_dato = "oppdatert_dato",
    oppdatert_av = "oppdatert_av",
    opprettet_dato = "opprettet_dato",
    nfs_status = "nfs_status",
    navigasjonsinstallasjon_eier = "navigasjonsinstallasjon_eier",
    sjomerke_nr = "sjomerke_nr",
    s57_status = "s57_status",
    gyldig_fra = "gyldig_fra",
    gyldig_til = "gyldig_til",
    kystverk_region = "kystverk_region",
    radar_reflektor = "radar_reflektor",
    farge_1 = "farge_1",
    farge_2 = "farge_2",
    farge_3 = "farge_3",
    merke_form = "merke_form",
    nav_id = "nav_id",
    toppmerke_type = "toppmerke_type",
    malt_av = "malt_av",
    malt_dato = "malt_dato",
    type_id = "type_id",
    sksd_status = "sksd_status",
    toppmerke_retning = "toppmerke_retning",
    bygg_tilstand = "bygg_tilstand",
    nautisk_tilstand = "nautisk_tilstand",
    nautisk_funksjon = "nautisk_funksjon",
    kystverk_rode = "kystverk_rode",
    pacc = "pacc",
    beliggenhet = "beliggenhet",
    navn = "navn",
    sted = "sted",
    vanndybde = "vanndybde",
    byggehoyde = "byggehoyde",
    klasse = "klasse",
    refleks_farge = "refleks_farge",
    kategori = "kategori",
    opprettet_av = "opprettet_av",
    merke_type = "merke_type",
    navigasjonsinstallasjon_eier_h = "navigasjonsinstallasjon_eier_h",
    type_id_h = "type_id_h",
    nedlagt_av = "nedlagt_av",
    nedlagt_dato = "nedlagt_dato",
    fjernet_av = "fjernet_av",
    fjernet_dato = "fjernet_dato",
    efs_melding = "efs_melding",
    efs_sendt_av = "efs_sendt_av",
}

export enum LayerFieldsFlytende {
    objectid = "objectid",
    globalid = "globalid",
    gis_obj_id = "gis_obj_id",
    pacc = "pacc",
    oppdatert_dato = "oppdatert_dato",
    oppdatert_av = "oppdatert_av",
    opprettet_dato = "opprettet_dato",
    nfs_status = "nfs_status",
    beliggenhet = "beliggenhet",
    navn = "navn",
    sted = "sted",
    navigasjonsinstallasjon_eier = "navigasjonsinstallasjon_eier",
    sjomerke_nr = "sjomerke_nr",
    s57_status = "s57_status",
    gyldig_fra = "gyldig_fra",
    gyldig_til = "gyldig_til",
    kystverk_region = "kystverk_region",
    vanndybde = "vanndybde",
    farge_1 = "farge_1",
    farge_2 = "farge_2",
    farge_3 = "farge_3",
    merke_type = "merke_type",
    nav_id = "nav_id",
    byggehoyde = "byggehoyde",
    malt_av = "malt_av",
    malt_dato = "malt_dato",
    klasse = "klasse",
    type_id = "type_id",
    sksd_status = "sksd_status",
    bygg_tilstand = "bygg_tilstand",
    nautisk_tilstand = "nautisk_tilstand",
    nautisk_funksjon = "nautisk_funksjon",
    kategori = "kategori",
    kystverk_rode = "kystverk_rode",
    fargemonster = "fargemonster",
    boye_form = "boye_form",
    sjomerke_type = "sjomerke_type",
    opprettet_av = "opprettet_av",
    radar_reflektor = "radar_reflektor",
    navigasjonsinstallasjon_eier_h = "navigasjonsinstallasjon_eier_h",
    type_id_h = "type_id_h",
    nedlagt_av = "nedlagt_av",
    nedlagt_dato = "nedlagt_dato",
    fjernet_av = "fjernet_av",
    fjernet_dato = "fjernet_dato",
    efs_melding = "efs_melding",
    merke_type_h = "merke_type_h",
    tilknyttet_lysboye = "tilknyttet_lysboye",
    efs_sendt_av = "efs_sendt_av",
}
